import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import './Modal.scss';
import Portal from './Portal';

export const Modal = ({ modalShow, handleModalShow, ...props }) => {

  const modalElement = useRef(null)

  const handlerKeyDown = (e) => {
    if (modalElement.current) {

      if (e.key === 'Escape') {
        handleModalShow()
        return true
      }

      // select only button elements
      const focusableElements = modalElement.current.querySelectorAll(
        'button'
      )
      const firstFocusableEl = focusableElements[0]
      const lastFocusableEl = focusableElements[focusableElements.length - 1]

      if (e.key === 'Tab') {
        if (e.shiftKey) /* shift + tab */ {
          if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            e.preventDefault();
          }
        } else /* tab */ {
          if (document.activeElement === lastFocusableEl) {
            firstFocusableEl.focus();
            e.preventDefault();
          }
        }
      }
    }

  }

  useEffect(() => {
    if (modalShow) {
      document.addEventListener('keydown', handlerKeyDown)
    }

    return () => {
      document.removeEventListener('keydown', handlerKeyDown)
    }
  }, [modalShow])

  //When modal is showing focus on the first accordion item
  useEffect(() => {
    if (modalShow) {
      document.body.setAttribute('data-scroll', 'disabled')

      if (modalElement.current) {
        const focusableElements = modalElement.current.querySelectorAll(
          'button'
        )

        if (focusableElements.length > 1) {
          // skip over close button and pick the first Accord item to focus
          const secondFocusableEl = focusableElements[1]
          secondFocusableEl.focus()
        }
        else {
          const focusableEl = focusableElements[0]
          focusableEl.focus()
        }

      }
    }
    else {
      document.body.removeAttribute('data-scroll')
    }

  }, [modalShow])

  return (
    <>
      {modalShow && (
        <Portal id={"modalRoot"} >
          <div className="c-modal" ref={modalElement}>
            <button className="c-modal__close-btn" onClick={() => handleModalShow()}>Close this</button>
            {props.children}
          </div>
        </Portal>
      )}
    </>
  )
}

Modal.propTypes = {
  modalShow: PropTypes.bool.isRequired,
}
